<script setup>
import { ref, watch, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import TableList from '@/components/lists/TableList.vue'
import PageNavigation from '@/components/navigate/PageNavigation.vue'
import Progress from '@/components/forms/Progress.vue'
import { useProvidersStore } from '@/store/providers'
import { normalizeApiError } from '@/utils/apiError'

const store = useProvidersStore()
const router = useRouter()
const route = useRoute()
const titles = ref([
  { title: 'Id', key: 'id' },
  { title: 'Назва', key: 'name' },
  { title: 'Курс', key: 'exchangeRate' },
])
const currentPage = ref(Number(route.query.page) || 1)
const type = ref('')
const errorMessage = ref('')

async function loadProviders(page = currentPage.value) {
  type.value = 'loading'
  errorMessage.value = ''

  try {
    await store.getProviders(page)
    type.value = ''
  } catch (error) {
    type.value = 'error'
    errorMessage.value = normalizeApiError(error, {
      fallbackMessage: 'Не вдалося завантажити список постачальників.',
    }).message
  }
}

onMounted(async () => {
  await loadProviders()
})

watch(currentPage, async (newPage) => {
  await router.push({ query: { page: newPage } })
  await loadProviders(newPage)
})
</script>

<template>
  <Progress :type="type" :error-message="errorMessage" loading-message="Завантаження списку..." />
  <TableList
    :rows="store.allProviders"
    :titles="titles"
    detailRoutName="providersDetail"
    importRoutName="providersImport"
    blockTitle="Постачальники"
  />
  <PageNavigation v-model="currentPage" :totalPages="store.countPages" :maxVisible="5" />
</template>
